import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppSelector} from '../../../../../hooks/runtime'
import {getEvent} from '../../../../../selectors/event'
import {getAdditionalFeesNote} from '../../../../../selectors/tax-and-fee'
import {a11yAdditionalFeesId} from '../../a11y'
import {classes} from './additional-fees-note.st.css'

export interface AdditionalFeesNoteProps {
  ticket: wix.events.ticketing.TicketDefinition
}

export const AdditionalFeesNote = ({ticket}: AdditionalFeesNoteProps) => {
  const {t} = useTranslation()
  const event = useAppSelector(getEvent)
  const note = getAdditionalFeesNote({event, ticket, t})

  if (!note) {
    return null
  }

  return (
    <Text
      id={a11yAdditionalFeesId(ticket.id)}
      tagName="p"
      className={classes.additionalFeesNote}
      data-hook={DH.ADDITIONAL_FEES_NOTE}
    >
      {note}
    </Text>
  )
}
